var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgBusiness = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 21V3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18H5Z",
  stroke: "currentColor",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 11H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2M17 8h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2",
  stroke: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--color-monochrome-white)",
  d: "M9 5h4M9 9h4M9 13h4M9 17h4"
}))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgBusiness);
export default ForwardRef;